<template>
    <div class="document-container acceptable_docs">
      <!-- <h2>LISTS OF ACCEPTABLE DOCUMENTS</h2> -->
      <p>
        All documents containing an expiration date must be unexpired.<br />
        * Documents extended by the issuing authority are considered unexpired.
      </p>
      <p>
        Employees may present one selection from List A or a combination of one selection from List B and one selection from List C.
        Examples of many of these documents appear in the Handbook for Employers (M-274).
      </p>
  
      <div class="lists">
        <!-- List A -->
        <div class="list">
          <div class="list-bg min-h-85">
          <h3>LIST A</h3>
          <h4>Documents that Establish Both Identity and Employment Authorization</h4>
           </div>
          <ul>
            <li>1. U.S. Passport or U.S. Passport Card</li>
            <li>2. Permanent Resident Card or Alien Registration Receipt Card (Form I-551)</li>
            <li>3. Foreign passport that contains a temporary I-551 stamp or temporary I-551 printed notation on a machine-readable immigrant visa</li>
            <li>4. Employment Authorization Document that contains a photograph (Form I-766)</li>
            <li>
              5. For an individual temporarily authorized to work for a specific employer because of his or her status or parole:
              <ul class="mt-3">
                <li>a. Foreign passport; and</li>
                <li>
                  b. Form I-94 or Form I-94A that has the following:
                  <ul>
                    <li>(1) The same name as the passport; and</li>
                    <li>
                      (2) An endorsement of the individual's status or parole as long as that period of endorsement has not yet expired and
                      the proposed employment is not in conflict with any restrictions or limitations identified on the form.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>6. Passport from the Federated States of Micronesia (FSM) or the Republic of the Marshall Islands (RMI) with Form I-94 or Form I-94A indicating nonimmigrant admission under the Compact of Free Association Between the United States and the FSM or RMI</li>
          </ul>
        </div>
        <span class="or-lbl">OR</span>
   
        <div class="list list-2">
          <div class="d-flex flex-col">
            <div class="d-flex list-ab">
              <div class="list-bg min-h-85 w-50">
                <h3>LIST B</h3>
                <h4>Documents that Establish Identity</h4>
              </div>
              <span class="or-lbl and-lbl">AND</span>
              <div class="list-bg min-h-85 w-50">
                <h3>LIST C</h3>
                <h4>Documents that Establish Employment Authorization</h4>
              </div>
            </div>
            <div class="d-flex gap-8">
              <ul class="w-50 ab-list">
            <li> 
              1. Driver’s license or ID card issued by a State or outlying possession of the United States provided it contains a photograph or information such as name, date of birth, sex, height, eye color, and address
            </li>
            <li> 
              2. ID card issued by federal, state, or local government agencies or entities, provided it contains a photograph or information such as name, date of birth, sex, height, eye color, and address
            </li>
            <li>3. School ID card with a photograph</li>
            <li>4. Voter’s registration card</li>
            <li>5. U.S. Military card or draft record</li>
            <li>6. Military dependent’s ID card</li>
            <li>7. U.S. Coast Guard Merchant Mariner Card</li>
            <li>8. Native American tribal document</li>
            <li>9. Driver’s license issued by a Canadian government authority</li>
            <li>
              <b>For persons under age 18 who are unable to present a document listed above:</b>
              <hr />
              <ul class="mt-3">
                <li>10. School record or report card</li>
                <li>11. Clinic, doctor, or hospital record</li>
                <li>12. Day-care or nursery school record</li>
              </ul>
            </li>
          </ul>
              <ul class="w-50 ab-list">
            <li>1. Social Security Account Number card, unless the card includes one of the following restrictions:
              <ul class="mt-3">
                <li>(1) NOT VALID FOR EMPLOYMENT </li>
                <li>(2) VALID FOR WORK ONLY WITH INS AUTHORIZATION </li>
                <li>(3) VALID FOR WORK ONLY WITH DHS AUTHORIZATION </li>
              </ul>
            </li> 
            <li>
              2. Certification of report of birth issued by the Department of State (Forms DS-1350, FS-545, FS-240)
            </li>
            <li>
              3. Original or certified copy of birth certificate issued by a state, county, municipal authority, or territory of the United States bearing an official seal
            </li>
            <li>4. Native American tribal document</li>
            <li>5. U.S. Citizen ID Card (Form I-197)</li>
            <li>6. Identification Card for Use of Resident Citizen in the United States (Form I-179)</li>
            <li>7. Employment authorization document issued by the Department of Homeland Security
              <ul class="mt-3">
                <li>For examples, see 
                  <a href="https://www.uscis.gov/i-9-central/form-i-9-resources/handbook-for-employers-m-274/70-evidence-of-employment-authorization-for-certain-categories" target="_blank">Section 7</a>
                   and 
                   <a href="https://www.uscis.gov/i-9-central/form-i-9-resources/handbook-for-employers-m-274/130-acceptable-documents-for-verifying-employment-authorization-and-identity" target="_blank">Section 13</a> of the M-274 on 
                   <a href="https://www.uscis.gov/i-9-central" target="_blank">uscis.gov/i-9-central.</a></li>
                <li>The Form I-766, Employment Authorization Document, is a List A, Item Number 4. document, not a List C document.</li>
              </ul>
            </li>
          </ul>
            </div>
          </div>
        </div>
      </div>
  
      <!-- <div class="acceptable-receipts">
        <h4>Acceptable Receipts</h4>
        <p>May be presented in lieu of a document listed above for a temporary period.</p>
        <p>For receipt validity dates, see the M-274.</p>
        <ul>
          <li>Receipt for a replacement of a lost, stolen, or damaged document</li>
          <li>Form I-94 issued to a lawful permanent resident that contains an I-551 stamp and a photograph of the individual.</li>
          <li>Form I-94 with “RE” notation or temporary Form I-551 printed notation or refugee stamp issued to a refugee</li>
        </ul>
        <ul>
        <li>Receipt for a replacement of a lost, stolen, or damaged List B document.</li>
        </ul>
        <ul>
        <li>Receipt for a replacement of a lost, stolen, or damaged List C document</li>
        </ul>
      </div> -->
      <div class="acceptable-receipts">
        <h4>Acceptable Receipts
          <p>May be presented in lieu of a document listed above for a temporary period.</p>
          <p>For receipt validity dates, see the M-274.</p>
        </h4>
      </div>
      <div class="lists">
        <!-- List A -->
          <div class="list">
            <div class="list-bg">
            <h3>LIST A</h3>
            </div>
            <ul>
              <li>1. Receipt for a replacement of a lost, stolen, or damaged List A document.</li>
              <li>2. Form I-94 issued to a lawful permanent resident that contains an I-551 stamp and a photograph of the individual.</li>
              <li>3. Form I-94 with “RE” notation or refugee stamp issued to a refugee.</li>
            </ul>
          </div>
          <!-- List B -->
          <div class="list">
            <div class="list-bg">
            <h3>LIST B</h3>
            </div>
            <ul>
              <li>1. Receipt for a replacement of a lost, stolen, or damaged List B document.</li>
            </ul>
          </div>
           <!-- List C -->
          <div class="list">
            <div class="list-bg">
            <h3>LIST C</h3>
            </div>
            <ul>
              <li>1. Receipt for a replacement of a lost, stolen, or damaged List C document.</li>
            </ul>
          </div>
        </div>
      <p class="pt-5 pb-5">*Refer to the Employment Authorization Extensions page on I-9 Central <a href="https://www.uscis.gov/i-9-central" target="_blank">(uscis.gov/i-9-central)</a> for more information. </p>
    </div>
  </template>

<script>
    export default {
    name: "DocumentList",
    };
</script>

<style scoped>
.document-container {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  padding: 20px;
}

h2,
h3,
h4 {
  text-align: center;
}

.lists {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 20px;
}

.list {
  width: 30%;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

li {
  margin-bottom: 10px;
}

.acceptable-receipts {
  margin-top: 20px;
}
</style>

  